import { Injectable } from '@angular/core';
import { MessageService } from '../../../../core';
import { FunilVendaEtapaMover } from '../fase/etapa';
import { from } from 'rxjs';

/** Service que valida os acessos e execuções de funcionalidades nos funis de vendas */
@Injectable({
    providedIn: 'root'
})
export class FunilVendaAuthGuardService {

    constructor(private messageService: MessageService) { }

    /** Valida se é permitido mover um negócio da etapa de origem (from) para a de destino (to) */
    canMoveEtapa(fromEtapa: FunilVendaEtapaMover, toEtapa: FunilVendaEtapaMover): boolean {
        // Sem etapa de origem
        if (!fromEtapa) {
            this.messageService.warning('Não foi possível mover por que a etapa de origem não foi informada. Tente novamente e se o problema persistir, entre em contato com o suporte', 'Atenção');
            return false;
        }
        // Sem etapa de destino
        if (!toEtapa) {
            this.messageService.warning('Não foi possível mover por que a etapa de destino não foi informada. Tente novamente e se o problema persistir, entre em contato com o suporte', 'Atenção');
            return false;
        }

        let isAllowed = false;

        // Tentando obter a etapa em que o negócio foi movido para verificar se ela pertencem as etapas que podem ser movidas a partir da etapa atual e se permite mover manualmente
        const proximaEtapa = fromEtapa.proximasEtapas.find(proximaEtapaFilter => proximaEtapaFilter.idProximaEtapa === toEtapa.id) ?? null;
        if (proximaEtapa && proximaEtapa.podeMoverManual) {
            isAllowed = true;
        }

        // Sem permissão para mover etapa
        if (!isAllowed) {
            this.messageService.warning(`Não é permitido mover de ${fromEtapa.nome} para ${toEtapa.nome}`, 'Sem Permissão');
            return false;
        }

        return true;
    }
}

